import { Box, Button, Center, Checkbox, Flex, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay, Text, useMediaQuery } from "@chakra-ui/react";
import { useBoolean } from "@laxmimanogna/code-quick-components";
import AppColors from "../../../constants/AppColors";
import { FONT_FAMILY } from "../../../constants/Theme";
import { useEffect } from "react";

const SubmitModal = (props) => {
    const [isNotSmallScren] = useMediaQuery('(min-width: 410px)');
    const [isChecked, icState] = useBoolean(props.isChecked);
    useEffect(() => {
        if (props.isOpen && props.isChecked) {
            icState.on();
        }
    }, [props.isChecked, props.isOpen]);

    return (
        <>
            <Modal
                isOpen={props.isOpen}
                size={'lg'}
                isCentered
            >
                <ModalOverlay style={{ backgroundColor: AppColors.lightSkyBlue }} />
                <ModalContent
                    p={15}
                    alignItems={'center'}
                >
                    <ModalHeader>
                        <Center fontSize={'xl'}
                            color={AppColors.secondary}
                            fontFamily={FONT_FAMILY.baiJamurjee}
                            fontWeight='bold'>
                                {props.confirmationMsg}
                        </Center>
                        
                    </ModalHeader>
                    <ModalBody mb={2}>
                        {props.checkBoxMsg && (
                            <Box textAlign="center" marginTop={-4} marginBottom={4}>
                            <Checkbox size='md' colorScheme={'secondary'} onChange={(e) => {
                                if (e.target.checked) {
                                    icState.on()
                                } else {
                                    icState.off()
                                }
                            }} 
                            isChecked={isChecked}>
                                <Text
                                    className="m-5"
                                    fontSize={'s'}
                                >
                                    {props.checkBoxMsg}
                                </Text>
                            </Checkbox>
                            {isChecked && (
                                <Text color="red.500" fontSize="sm">
                                {props.confirmationWarning}
                                </Text>
                            )}
                            
                            </Box>
                            )
                        }
                        
                        <Flex
                            alignItems={'center'}
                            direction={isNotSmallScren ? 'row' : 'column'}
                        >
                            <Button
                                variant="outline"
                                mr={0}
                                borderRadius={25}
                                fontWeight={500}
                                outline={'2px solid #023B93'}
                                paddingInline={'35px'}
                                backgroundColor={AppColors.white}
                                marginBottom={isNotSmallScren ? '0px' : '10px'}
                                onClick={() => {
                                    props.onClose()
                                    icState.off();
                                }}
                                fontSize={'sm'}

                            >
                                {props.cancelMsg}
                            </Button>
                            <Button
                                ml={isNotSmallScren ? 10 : 0}
                                borderRadius={25}
                                color={AppColors.white}
                                paddingInline={'35px'}
                                backgroundColor={AppColors.primary}
                                fontWeight='normal'
                                fontSize={'sm'}
                                disabled={(!isChecked && !props.isActivation) || !props.checkBoxMsg}
                                onClick={async () => {
                                    await props.handleConfirmation(isChecked);
                                    icState.off();
                                }}
                            >
                                {props.confirmMsg}
                            </Button>
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
}
export default SubmitModal